import { ErrorMessages } from '../enums/error-messages.enum';

export const getErrorMessage = (errorMessage: string): string => {
    const errors = {
        'Wrong password or email': ErrorMessages.WRONG_PASSWORD,
        'User not found': ErrorMessages.USER_NOT_FOUND,
        'Invalid email': ErrorMessages.INVALID_EMAIL,
        "Passwords don't match": ErrorMessages.PASSWORDS_NOT_MATCH,
        'Password change failed!': ErrorMessages.CHANGE_PASSWORD_FAILED,
        'coverageDistance must be a number': ErrorMessages.COVERAGE_DISTANCE_MUST_BE_A_NUMBER,
        'Reset password link has been sent to your email': ErrorMessages.RESET_PASSWORD_LINK_SENT_TO_EMAIL,
        'Reset password token is not valid': ErrorMessages.RESET_PASSWORD_TOKEN_NOT_VALID,
        'No se puede registrar al conductor ya que existe otro con el mismo correo.': ErrorMessages.DRIVER_ALREADY_EXISTS,
    };

    for (const [message, key] of Object.entries(errors)) {
        if (errorMessage.includes(message)) {
            return key;
        }
    }

    return ErrorMessages.UNKNOWN_ERROR;
};
